import { render, staticRenderFns } from "./trialZaxis.vue?vue&type=template&id=643617e6&scoped=true&"
import script from "./trialZaxis.vue?vue&type=script&lang=js&"
export * from "./trialZaxis.vue?vue&type=script&lang=js&"
import style0 from "./trialZaxis.vue?vue&type=style&index=0&id=643617e6&lang=scss&scoped=true&"
import style1 from "./trialZaxis.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643617e6",
  null
  
)

export default component.exports